module.exports = __webpack_public_path__ + "static/media/Milex-Ring-Pessary-Instructions-for-Use.b5323c78.jpg";